<template>
  <div class="header-content" @click="_handleToHomePage">
    <img src="../assets/img/logo.png" alt="logo" class="logo-img">
<!--    <div class="header-title">中国科技创新协会</div>-->
  </div>
  <div class="nav-con">
    <div v-for="item in swiperData"
         :key="item.value" class="nav-out-con"
         @mouseover="_movePointerPear(item.id)" @mouseleave="_movePointerOut(item.id)">
      <div v-if="item.hover" class="nav-menu-show">
        <div v-for="itemInner in item.children" :key="itemInner.id" class="nav-span"
             @click="_handleToNavChild(itemInner.label)">
          {{ itemInner.label }}
        </div>
      </div>
      <div v-if="item.select" class="nav-section nav-select" v-on:click="_tapHeader(item.id)">
        {{ item.label }}
        <span style="font-size: 8px;margin-left: 4px;">{{ item.id === 2 || item.id === 3 ? '▼' : '' }}</span>
      </div>
      <div v-if="!item.select" class="nav-section nav-un-select" v-on:click="_tapHeader(item.id)">
        <span>{{ item.label }}
        <span style="font-size: 8px;margin-left: 4px;">{{ item.id === 2 || item.id === 3 ? '▼' : '' }}</span>
        </span>
      </div>
    </div>
  </div>
  <div class="nav-selection"></div>
  <div v-if="nowSelect !== 0" class="nav-bottom-con">
    <span>首页</span>
    <span style="margin: 0 10px;">></span>
    <div v-for="(item, index) in swiperData" :key="index" style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;">
      <span v-if="item.select">{{item.label}}</span>
      <div v-for="(itemInner, indexInner) in item.children" :key="indexInner">
        <span v-if="itemInner.select" style="margin: 0 10px;">></span>
        <span v-if="itemInner.select">{{itemInner.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    callBack: Function
  },
  created() {
    this.index = this.$route.query.id === undefined ? 0 : parseInt(this.$route.query.id)
    this.nowSelect = this.index
    for (let i = 0;i < this.swiperData.length;i++) {
      if (this.index === this.swiperData[i].id) {
        this.swiperData[i].select = true
      } else {
        this.swiperData[i].select = false
      }
    }
  },
  data() {
    return {
      index: 0,
      nowSelect: 0,
      swiperData: [
        {
          label: '首页',
          select: true,
          hover: false,
          id: 0,
          children: []
        },
        {
          label: '会员中心',
          select: false,
          hover: false,
          id: 1,
          children: []
        },
        {
          label: '协会概况',
          select: false,
          hover: false,
          children: [
            {
              label: '中国科技创新协会协会简介',
              id: 0,
              select: false
            },
            {
              label: '中国科技创新协会协会章程',
              id: 1,
              select: false
            }
          ],
          id: 2
        },
        {
          label: '新闻中心',
          select: false,
          hover: false,
          id: 3,
          children: [
            {
              label: '协会资讯',
              id: 0,
              select: false
            },
            {
              label: '行业资讯',
              id: 1,
              select: false
            }
          ],
        },
        {
          label: '活动信息',
          select: false,
          hover: false,
          id: 4,
          children: []
        }
      ]
    }
  },
  methods: {
    _handleToNavChild(e) {
      let children = 0
      const swiperData = this.swiperData
      for (let i = 0; i < swiperData.length; i++) {
        let isNow = false
        for (let ii = 0; ii < swiperData[i].children.length; ii++) {
            if (swiperData[i].children[ii].label === e) {
              isNow = true
              children = swiperData[i].children[ii].id
              swiperData[i].children[ii].select = true
              console.log(swiperData[i].children[ii].select)
            } else {
              swiperData[i].children[ii].select = false
            }
        }
        if (isNow) {
          this.index = parseInt(i)
          this.nowSelect = this.index
          swiperData[i].hover = false
          swiperData[i].select = true
        } else {
          swiperData[i].hover = false
          swiperData[i].select = false
        }
      }
      this.swiperData = swiperData
      this.$router.push({
        path: '/OutViewFace',
        query: {
          id: this.index,
          child: children
        }
      })
      this.callBack("change")
    },
    _tapHeader(e) {
      for (let i = 0; i < this.swiperData.length; i++) {
        // 子类选中状态归零
        for (let ii = 0; ii < this.swiperData[i].children.length; ii ++) {
          this.swiperData[i].children[ii].select = false
        }
        // end
        if (parseInt(e) === this.swiperData[i].id) {
          this.swiperData[i].select = true
          this.index = parseInt(e)
          this.nowSelect = this.index
        } else {
          this.swiperData[i].select = false
        }
        this.swiperData[i].hover = false
      }
      this.$router.push({
        path: this.index === 0 ? '/' : '/OutViewFace',
        query: {
          id: this.index,
          child: null
        }
      })
      if (this.index !== 0) {
        this.callBack("change")
      }
    },
    _movePointerPear(e) {
      for (let i = 0; i < this.swiperData.length; i++) {
        if (parseInt(e) === this.swiperData[i].id) {
          if (parseInt(e) === 2 || parseInt(e) === 3) {
            this.swiperData[i].hover = true
          }
        }
      }
    },
    _movePointerOut(e) {
      for (let i = 0; i < this.swiperData.length; i++) {
        if (parseInt(e) === this.swiperData[i].id) {
          this.swiperData[i].hover = false
        }
      }
    },
    _handleToHomePage() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped>
.header-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  cursor: pointer;
}

.logo-img {
  width: auto;
  height: 60px;
}

.header-title {
  color: #444;
  font-size: 50px;
  font-family: "Heiti SC";
  font-weight: bold;
  margin-left: 20px;
}

.nav-out-con {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;

}

.nav-con {
  background: hsla(200, 2%, 25%, 0.8) !important;
  height: 50px;
  padding: 0 2%;
  width: 96%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.nav-selection {
  background: #cd2122;
  width: 100%;
  height: 6px;
}
.nav-bottom-con {
  width: 94%;
  padding: 0 3%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  font-weight: bold;
  color: #333333;
  height: 40px;
  border-bottom: 1px solid #dddddd;
}

.nav-section {
  width: 120px;
  height: 92%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
}

.nav-un-select {
  color: #ffffff;
}

.nav-select {
  color: #cd2122;
  background: #ffffff;
  font-weight: bold;
}

.nav-con .nav-menu-show {
  position: absolute;
  height: auto;
  padding: 10px 10px;
  z-index: 999;
  top: 50px;
  left: -1px;
  background: hsla(200, 2%, 25%, 0.8) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
}

.nav-con .nav-menu-show .nav-span {
  color: #ffffff;
  min-width: 200px;
  font-size: 16px;
  height: 40px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>